'client-only';

import { useContext } from 'react';

import { VisitContext } from '../contexts/visitContext';

export const useVisitContext = () => {
  const context = useContext(VisitContext);
  if (!context) {
    return { visit: undefined, setVisit: () => {} };
  }

  return context;
};
